import {
  ComunicatingReason,
  ConnectedComputersIcon,
  LastCommunicatedOn,
  TotalCommunicationIcon,
} from "icons";
import { Card } from "../card";
import { TicketCard } from "../ticketCard";
import styles from "./styles.module.scss";
import { Activity } from "../activity";

export const CommunicationReasons = ({ heightOfTicketContainer }) => {
  const cardsData = [
    {
      title: "Total Communication",
      value: 50,
      icon: TotalCommunicationIcon,
      color: "black",
    },
    {
      title: "Last Communicated On",
      value: "02.03.25",
      icon: LastCommunicatedOn,
      color: "black",
    },
    {
      title: "Last Communicated with",
      value: "Benet",
      icon: LastCommunicatedOn,
      color: "#46B764",
    },
    {
      title: "Communicated Reasons",
      value: "Capturing",
      icon: ComunicatingReason,
      color: "#006AB3",
    },
  ];

  return (
    <div className={styles.reasonsContainer}>
      <div className={styles.cards}>
        {cardsData.map((item) => (
          <Card key={item.title} item={item} />
        ))}
      </div>
      <h3 className={styles.count}>Count: 100</h3>
      <div
        className={styles.ticketSection}
        style={{ height: `${heightOfTicketContainer}` }}
      >
        <div className={styles.list}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
            <TicketCard key={item} />
          ))}
        </div>
        <div className={styles.messenger}>
          <Activity
          // singleTicketData={singleTicketData}
          // totalMessages={totalMessages}
          // setTotalMessages={setTotalMessages}
          // ticketId={ticketData?.ticket_id}
          />
        </div>
      </div>
    </div>
  );
};
